// extracted by mini-css-extract-plugin
export default {"root":"PortfolioPage_root__fAfPO"};